import { BUTTONS, TEXT, TITLE } from '../../../modals/universalModal'

export default function createInteractiveShopModal({ title, text, button, onClick }) {
  return {
    type: 'universalModal',
    props: {
      modalProps: {
        wrapper: { isFullPage: false, isVisibleBg: false },
        modifier: ['interactive-shop'],
      },
      components: [
        {
          list: [
            {
              type: TITLE,
              props: {
                modifier: ['padding-no'],
                value: title,
              },
            },
            {
              type: TEXT,
              props: {
                value: text,
              },
            },
            {
              type: BUTTONS,
              props: {
                buttons: [{ text: 'other.ok', ...button, onClick }],
              },
            },
          ],
        },
      ],
    },
  }
}
